import React from 'react';
import PropTypes from 'prop-types';
import ImportDescriptionPanel from "./comp/importDescriptionPanel/ImportDescriptionPanelConnector";
import FilePropertiesPanel from './comp/filePropertiesPanel/FilePropertiesPanelConnector';
import ColumnMappingPanel from './comp/columnMappingPanel/ColumnMappingPanelConnector';
import AuditSelectionSection from './comp/auditSelectionSection/AuditSelectionSection';
import RulesPanel from './comp/rulesPanel/RulesPanelConnector';
import './manageImportProfilePage.scss';
import ProfileActionsSection from "./comp/profileActionsSection/ProfileActionsSectionConnector";
import ProfileDataFileParser from "./comp/profileDataFileParser/ProfileDataFileParserConnector";
import { NEW, UPDATE } from 'shared/constants/SharedConstants';

const initialState = {
  fileName: '',
  acceptedFiles: [],
  rejectedFiles: [],
  uploadStep: 'upload'
};

class ManageImportProfilePage extends React.Component {
  constructor(props){
    super(props);
    this.state = { ...initialState };
    if (props.location.pathname === '/edit-import-profile') {
      this.mode = UPDATE;
      this.props.profileActions.setProfileEditionMode();
    }
    else {
      this.mode = NEW;
      this.props.profileActions.resetProfileEditionMode();
    }
    this.title = `${this.mode} Import Profile`;
    document.title = this.title;
    this.props.profileActions.resetProfile();
  }
  
  componentDidMount() {
    const { pathname, state: locationState } = this.props.location;
    if(pathname === '/edit-import-profile' && locationState && locationState.profileId){
      this.props.profileActions.fetchProfileById(locationState.profileId);
    }
  }
  
  handleDropFiles = (acceptedFiles, rejectedFiles) => (
    this.setState({
      acceptedFiles,
      rejectedFiles,
      fileName: acceptedFiles.length === 1 ? acceptedFiles[0].name : ''
    })
  );

  handleResetData = () => this.setState({ ...initialState });

  render(){
    const { acceptedFiles, rejectedFiles, uploadStep } = this.state;
    const { fetchingProfile } = this.props;
    return (
      <div className="manage-imp-profile__page react-page">
        <h1>{ this.title }</h1>
        <hr />
        <ImportDescriptionPanel loading={ fetchingProfile } disabled={ this.mode === UPDATE } />
        <ProfileDataFileParser
          acceptedFiles={ acceptedFiles }
          rejectedFiles={ rejectedFiles }
          url="/"
          onDropFiles={ this.handleDropFiles }
          uploadStep={ uploadStep }
          loading={ fetchingProfile }
          disabled={ this.mode === UPDATE }
        />
        <FilePropertiesPanel loading={ fetchingProfile } />
        <ColumnMappingPanel acceptedFiles={ acceptedFiles } mode={ this.mode } />
        <AuditSelectionSection loading={ fetchingProfile } />
        <RulesPanel loading={ fetchingProfile } />
        <ProfileActionsSection onResetData={ this.handleResetData } mode={ this.mode } />
      </div>
    );
  }
}

ManageImportProfilePage.propTypes = {
  location: PropTypes.shape().isRequired,
  fetchingProfile: PropTypes.bool,
  profileActions: PropTypes.shape({
    fetchProfileById: PropTypes.func,
    resetProfile: PropTypes.func,
    setProfileEditionMode: PropTypes.func,
    resetProfileEditionMode: PropTypes.func
  })
};

ManageImportProfilePage.defaultProps = {
  profileActions: {
    fetchProfileById: () => null,
    resetProfile: () => null,
  },
  fetchingProfile: false
};

export default ManageImportProfilePage;



// WEBPACK FOOTER //
// ./src/components/importProfile/ManageImportProfilePage.js